
import { PropTypes } from 'prop-types';
const RichText = ({ text }) => {
    return (
        <p className='whitespace-pre-line w-auto'>
            {
                text
            }
        </p>
    )
}
RichText.propTypes = {
    text: PropTypes.string
}
export default RichText